module.exports = __webpack_public_path__ + "img/envelope-one.0a45b222.svg";